export default {
  dataType: {
    DataIdentifier: 'Signál',
    MeaningIdentifier: 'Význam',
  },
};
